module.exports = __webpack_public_path__ + "static/media/n1.3400037f.png";